import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-24 bg-white" data-id="element-90">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-92">
          <h2 className="text-3xl lg:text-4xl font-medium text-brown mb-8 leading-tight" data-id="element-93">
            Hoy en día, muchas personas sienten que su rutina de cuidado facial
            es complicada, costosa o simplemente no saben por dónde empezar.
          </h2>
          <p className="text-xl text-brown/70 font-light leading-relaxed mb-10" data-id="element-94">
            Demasiados productos… demasiada información… y poca claridad sobre
            qué hacer realmente.
          </p>
          <p className="text-2xl lg:text-3xl font-serif font-medium text-olive leading-snug" data-id="element-95">
            No necesitas más productos… necesitas una forma más simple de
            hacerlo.
          </p>
        </motion.div>
      </div>
    </section>;
}